var map = {
	"./logo_border_star_00000.png": 413,
	"./logo_border_star_00001.png": 414,
	"./logo_border_star_00002.png": 415,
	"./logo_border_star_00003.png": 416,
	"./logo_border_star_00004.png": 417,
	"./logo_border_star_00005.png": 418,
	"./logo_border_star_00006.png": 419,
	"./logo_border_star_00007.png": 420,
	"./logo_border_star_00008.png": 421,
	"./logo_border_star_00009.png": 422,
	"./logo_border_star_00010.png": 423,
	"./logo_border_star_00011.png": 424,
	"./logo_border_star_00012.png": 425,
	"./logo_border_star_00013.png": 426,
	"./logo_border_star_00014.png": 427,
	"./logo_border_star_00015.png": 428,
	"./logo_border_star_00016.png": 429,
	"./logo_border_star_00017.png": 430,
	"./logo_border_star_00018.png": 431,
	"./logo_border_star_00019.png": 432,
	"./logo_border_star_00020.png": 433,
	"./logo_border_star_00021.png": 434,
	"./logo_border_star_00022.png": 435,
	"./logo_border_star_00023.png": 436,
	"./logo_border_star_00024.png": 437,
	"./logo_border_star_00025.png": 438,
	"./logo_border_star_00026.png": 439,
	"./logo_border_star_00027.png": 440,
	"./logo_border_star_00028.png": 441,
	"./logo_border_star_00029.png": 442
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-star nonrecursive \.(png)$
// module id = 412
// module chunks = 0